























































import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import {
    BetlerWelcomeBonus,
    WelcomeBonusDescription,
} from '@core/models/bonus/WelcomeBonus';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import {
    respondToAbove,
    ScreenWidth,
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { WelcomeOfferBonusType } from '@core/models/bonus/WelcomeOfferBonusType';

export default defineComponent({
    name: 'PromotionWelcomeOfferDetails',
    props: {
        welcomeBonuses: {
            type: Array as PropType<BetlerWelcomeBonus[]>,
            required: false,
            default: () => ([]),
        },
    },
    setup() {
        const { translate } = useI18n();
        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const setModal = modalModule.action('setModal');

        const isDesktopLayout = respondToAbove(ScreenWidth.tSm);

        function getUsageDescriptionText(bonusDescription: WelcomeBonusDescription, bonusAward: string) {
            const title = `<div class="promotion-welcome-offer__tooltip-title">${bonusDescription.title}</div>`;
            const award = `<div class="promotion-welcome-offer__tooltip-award">${bonusAward}</div>`;
            // eslint-disable-next-line sonarjs/no-nested-template-literals
            const conditions = bonusDescription.conditions.length > 0 ? `<ul>${bonusDescription.conditions.map((condition) => `<li>${condition}</li>`).join('')}</ul>` : '';

            return `<div class="promotion-welcome-offer__tooltip">
                ${title}
                ${translate('bonus.common.you_will_receive')}
                ${award}
                ${conditions}
            </div>`;
        }

        function openDescriptionModal(bonusDescription: WelcomeBonusDescription, bonusAward: string, bonusType: WelcomeOfferBonusType) {
            if (!isDesktopLayout) {
                setModal({
                    code: modalCodes.tooltipInfo,
                    title: bonusDescription.title,
                    data: {
                        titleText: bonusAward,
                        bonusConditions: bonusDescription.conditions,
                        bonusDescription: bonusType === WelcomeOfferBonusType.Sport ? translate('bonus.welcome_offer.explanation_sport_bonus') : translate('bonus.welcome_offer.explanation_casino_bonus'),
                    },
                    isClosable: false,
                });
            }
        }

        return {
            isDesktopLayout,
            getUsageDescriptionText,
            openDescriptionModal,
        };
    },
    components: { SdsIcon },
});
